/** @format */

export enum Role {
  SuperAdmin = 'Super Admin',
  Admin = 'Admin',
  SuperUser = 'Super User',
  User = 'User',
}
